import ButtonLoader from "HELPDESK/CommonResources/ButtonLoader/ButtonLoader";
import React, { Component, createRef } from 'react';
import 'HELPDESK/Components/QueryDetails/ViewRequestModal/QuotationApproval/quotationapproval.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import config from 'config';
import HelpdeskApiCall from "HelpdeskApiCall";
import vmeduLogo from "HELPDESK/CommonResources/images/vmeduLogo.svg";
import printApprovalformIcon from "HELPDESK/CommonResources/images/printApprovalformIcon.svg";
import ReactToPrint from "react-to-print";
import { Base64 } from "js-base64";
import axios from 'axios';

export class QuotationApproval extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estimationList: {},
            serviceRequestId: this.props.currentQueryRequestId,
            newEstimationRows: {},
            finalEstimate: [
                "SRD Preparation",
                "UX and Prototyping",
                "API and Backend Development",
                "Frontend Development",
                "QA and Security Testing",
                "Deployment and Documentation"
            ],
            contentListFetching: false,
            openEstimation: false,
            currentClientResponse: this.props.currentClientResponse,
            isAddingEstimation: false,
            estimationAdding: false,
            estimationUpdating: false,
            componentRef: createRef(),
            instituteDetailsLoading: false,
            instituteDetails: {},
            estimationData: {},
            requestUpdateStatusId: null,
            requestUpdateStatusName: '',
            requestTypeCompletionStatus: {},
            queryStatusLoading: false,
            enhancementQueryFetching: false



        };
    }

    componentDidMount() {
        if (this.state.serviceRequestId) {
            this.apiCallToGetEstimationCostList();
            this.apiCallToGetInstituteDetails()
            this.apiCallToGetEnhancementQueryStatus()
        }
    }

    apiCallToGetEstimationCostList = async () => {
        this.setState({ addingEstimation: true });

        let requestData = {
            "iid": config.institute_id,
            "serviceRequestId": this.state.serviceRequestId,
            "addedBy": config.userId
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'pmTool_getSrWiseCostEstimation',
            requestData,
            '/api/projectManagement/Queries/pmTool_userServiceRequestReceivedData.php'
        );

        if (jsonResponse.success) {
            if (jsonResponse.APIResult.status === 'fail') {
                let apiResult = jsonResponse.APIResult.data.length > 0 ? JSON.parse(jsonResponse.APIResult.data) : {};
                let newEstimationRows = {};
                this.setState({
                    estimationList: Object.values(apiResult)[0],
                    estimationData: jsonResponse.APIResult,
                    newEstimationRows,
                    estimationAdding: apiResult.length === 0,
                    // totalGrandCostEstimation: jsonResponse.APIResult?.grandTotalCost ? jsonResponse.APIResult?.grandTotalCost : 0,
                });

            } else {
                let apiResult = jsonResponse.APIResult.data;
                let newEstimationRows = {};
                const estimationData = Object.values(apiResult)[0];

                if (estimationData && typeof estimationData === 'object') {
                    Object.values(estimationData).forEach(item => {
                        newEstimationRows[item.team] = item.manHrs;
                    });
                }


                this.setState({
                    estimationList: Object.values(apiResult)[0],
                    estimationData: jsonResponse.APIResult,
                    newEstimationRows,
                    estimationAdding: apiResult.length === 0,
                    // totalGrandCostEstimation: jsonResponse.APIResult?.grandTotalCost ? jsonResponse.APIResult?.grandTotalCost : 0,
                });

            }

            // debugger;
        } else {
            this.setState({ newEstimationRows: {}, estimationList: {}, estimationAdding: true, estimationData: {} });
        }
    };

    apiCallToGetInstituteDetails = async () => {
        this.setState({ instituteDetailsLoading: true });
        let requestData = {
            'iid': config.institute_id,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'getInstituteDetailsByIID',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {


                this.setState({ instituteDetailsLoading: false, instituteDetails: jsonResponse.APIResult.data });

            } else {
                toast.error("Something Went wrong While fetching instituteDetails");
                this.setState({ instituteDetailsLoading: false });
            }
        }
    };

    // UPDATE OR CLOSE  QUERY STATUS
    apiCallToUpdateEnhancementCurrentQueryStatus = async () => {
        this.setState({
            queryStatusLoading: true,
        });

        try {
            let userId = config.faculty_id;
            let formData = new FormData();
            const requestData = {
                "iid": config.institute_id,
                "serviceRequestId": this.state.serviceRequestId,
                "updatedBy": config.faculty_id,
                "updatingStatusId": this.state.requestUpdateStatusId,
                "updatingStatusName": this.state.requestUpdateStatusName,
                "srType": "enhancements"

            }


            formData.append('helpDesk_updateClientWiseEnhancementRequestStatus', true);
            formData.append('data', Base64.encode(JSON.stringify(requestData)));

            let parameterData = {
                source: 'app',
                uid: userId,
                email: config.emailId,
                role: 'instructor'
            };

            formData.append('tokenInputParameter', Base64.encode(JSON.stringify(parameterData)));


            const headers = {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
                "Authorization": "Basic " + config.user_token
            };

            // Send the API request
            const response = await axios.post(config.RootUrl + '/api/helpDesk/clientServiceRequest/help_deskClientServiceRequest.php', formData, { headers });
            // Handle the API response

            let jsonResponse = response.data;
            if (jsonResponse.success === true || jsonResponse.success === "true") {

                if (jsonResponse.status === 'success') {
                    this.setState({ queryStatusLoading: false, requestUpdateStatusId: null, requestUpdateStatusName: "" });
                    toast.success(jsonResponse.message);
                    this.props.onCloseModal();


                } else {
                    this.setState({ queryStatusLoading: false, });
                    toast.warning(jsonResponse.message);
                }



            } else {
                toast.error("Something went wrong while Updating Service Request Status.");
                // clear all the stat
                this.setState({ queryStatusLoading: false, });

            }
        } catch (error) {

            toast.error("Something went wrong while Updating and going catch Service Request Status.");
            this.setState({ queryStatusLoading: false });
        }
    };

    // GET CURRENT QUERY STATUS
    apiCallToGetEnhancementQueryStatus = async () => {
        // this.setState({
        //     enhancementQueryFetching: true,
        // })
        const requestData = {
            serviceRequestId: this.state.serviceRequestId,
            facultyId: config.faculty_id,
            iid: config.institute_id,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'helpDesk_getClientWiseEnhancementWorkFlowStatus',
            requestData,
            '/api/helpDesk/clientServiceRequest/help_deskClientServiceRequest.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetEnhancementQueryStatus();
            }, 1000);
        } else {
            if (jsonResponse.success) {

                // if (jsonResponse.APIResult.status === 'success') {
                let apiResult = jsonResponse.APIResult.data;


                this.setState({ requestTypeCompletionStatus: apiResult });


            } else {
                console.error("Something went wrong while fetching the data.");

                toast.error(jsonResponse.message)
                this.setState({ requestTypeCompletionStatus: {}, enhancementQueryFetching: false });
            }
        }
    }
    render() {
        const { estimationList, instituteDetails, estimationData } = this.state;
        return (
            <div className='approvalTable'>
                <div className="flex-row-approval" style={{ alignItems: 'center' }}>
                    <p className="vm_custom_subtitle5">Quotation</p>
                    {/*  */}
                    <div className="flex-row-hd-button" >

                        <ReactToPrint
                            trigger={() =>

                                <button style={{ cursor: 'pointer' }} className="print-hd-apr" title="Click to print">
                                    <img src={printApprovalformIcon} id="" alt="print-approval-form" />
                                </button>
                            }
                            content={() => this.state.componentRef.current}
                        />

                        {/* 2 button     Cancel Request and Approve and Pa
                        y */}
                        {this.props.adminUpdateStatus == 'Admin Document Approval' &&
                            <>
                                <button className="cancel-hd-apr vm_custom_body3"
                                    onClick={() => {
                                        const selectedStatus = Object.values(this.state.requestTypeCompletionStatus)
                                            .find(item => item.statusName === 'Close');
                                        if (selectedStatus) {
                                            this.setState({
                                                requestUpdateStatusId: selectedStatus.statusId,
                                                requestUpdateStatusName: selectedStatus.statusName
                                            }, () => {
                                                this.apiCallToUpdateEnhancementCurrentQueryStatus();
                                            });
                                        }
                                    }}
                                >Cancel Request</button>
                                <button className="approve-hd-apr vm_custom_body3"
                                    onClick={() => {
                                        const selectedStatus = Object.values(this.state.requestTypeCompletionStatus)
                                            .find(item => item.statusName === 'Quotation Approval by Client');
                                        if (selectedStatus) {
                                            this.setState({
                                                requestUpdateStatusId: selectedStatus.statusId,
                                                requestUpdateStatusName: selectedStatus.statusName
                                            }, () => {
                                                this.apiCallToUpdateEnhancementCurrentQueryStatus();
                                            });
                                        }
                                    }}
                                    disabled={this.props.adminUpdateStatus != 'Admin Document Approval'}
                                >Approve & Pay</button>
                            </>
                        }

                    </div>
                </div>
                <div className="approvalForm" ref={this.state.componentRef}>
                    <div className="flex-col-approval" >
                        <div className="flex-row-approval" >
                            <p className="vm_custom_title4">Vmedulife Software</p>
                            <img src={vmeduLogo} alt="vmeduLogo" />

                        </div>
                        <div className="flex-row-approval">
                            <span className="vm_custom_overline">2nd Floor, EFC Business Centre, Hinjewadi Phase 1 Rd, Hinjewadi Rajiv Gandhi Infotech Park, Pune, Maharashtra 411057</span>
                            <span className="vm_custom_overline" style={{ justifyContent: 'flex-end' }}>
                                <p className="vm_custom_overline">Tel: 9623964758</p>
                                <p className="vm_custom_overline">Email: Sales@vmedulife.com</p>
                            </span>

                        </div>


                    </div>
                    <div className="quotation-title">
                        <span className="vm_custom_title5" style={{ color: '#FFFFFF' }}>QUOTATION</span>
                    </div>
                    <div className="table-responsive col-md-12" style={{ width: '100%', maxHeight: '60vh', overflowY: 'auto' }}>
                        <table className="table table-bordered" style={{ width: '100%', borderCollapse: 'collapse', border: '1.01px solid #E0E8EF' }}>
                            <thead style={{ backgroundColor: "#F5F8FA", position: 'sticky', top: '0', zIndex: 1, borderBottom: '1px solid #E0E8EF' }}>
                                <tr>
                                    <th className="vm_custom_body3" style={{ padding: '5px 5px', backgroundColor: "#F9FAFB", border: '1.01px solid #E0E8EF' }}>Customer Details</th>
                                    <th className="vm_custom_body3" style={{ padding: '5px 5px', backgroundColor: "#F9FAFB", border: '1.01px solid #E0E8EF' }}>Request Details</th>

                                </tr>
                            </thead>
                            <tbody>


                                <tr>
                                    <td className="table-rows vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>
                                        <p className="vm_custom_body3" >
                                            <span style={{ fontWeight: 'bold' }}>Organization Name : </span>
                                            {instituteDetails.InstituteName}
                                        </p>
                                        <p className="vm_custom_body3" > Address : {instituteDetails.Address}</p>
                                        <p className="vm_custom_body3" >Country : {instituteDetails.Country}</p>
                                        <p className="vm_custom_body3" >Phone : {instituteDetails.Phone}</p>
                                    </td>
                                    <td className="table-rows vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>

                                        <p className="vm_custom_body3" >
                                            <span style={{ fontWeight: 'bold' }}>Quotation ID :</span>
                                            {this.props.currentQueryRequestId ?? "-"}</p>

                                        <p className=" vm_custom_body3" >
                                            <span style={{ fontWeight: 'bold' }}>    Date :</span>
                                            {estimationData.addedOnDate?.toString()}

                                        </p>
                                    </td>

                                </tr>

                            </tbody>
                        </table>

                    </div>
                    <div className="table-responsive col-md-12" style={{ width: '100%', maxHeight: '60vh', overflowY: 'auto' }}>
                        <table className="table table-bordered" style={{ width: '100%', borderCollapse: 'collapse', border: '1.01px solid #E0E8EF' }}>
                            <thead style={{ backgroundColor: "#F5F8FA", position: 'sticky', top: '0', zIndex: 1, borderBottom: '1px solid #E0E8EF' }}>
                                <tr>
                                    <th className="vm_custom_body3" style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Sr.No.</th>
                                    <th className="vm_custom_body3" style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Tasks</th>
                                    <th className="vm_custom_body3" style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Cost</th>

                                    <th className="vm_custom_body3" style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>
                                        Estimated Man Hours
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {

                                    Object.keys(this.state.newEstimationRows).length > 0 ?
                                        this.state.finalEstimate.map((estimationTeamName, index) => (
                                            <tr key={index}>
                                                <td className="table-rows vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>{index + 1}</td>
                                                <td className="table-rows vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>{estimationTeamName}</td>
                                                <td className="table-rows vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>{this.state.estimationList[estimationTeamName]?.cost ?? "0"}</td>

                                                <td className="table-rows vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>
                                                    {
                                                        this.state.newEstimationRows[estimationTeamName] || '-'
                                                    }
                                                </td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan={4} className="table-rows vm_custom_body3 text-center" style={{ border: '1.01px solid #E0E8EF' }}>No estimation data found.</td>
                                            </tr>
                                        )}
                            </tbody>
                            <tfoot style={{ backgroundColor: "#F5F8FA", position: 'sticky', top: '0', zIndex: 1, borderBottom: '1px solid #E0E8EF' }}>
                                <tr>
                                    <td className="vm_custom_body3" style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}></td>
                                    <td className="vm_custom_body3" style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}> Total</td>
                                    <td className="vm_custom_body3" style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}> ₹ {estimationData.grandTotalCost}</td>

                                    <td className="vm_custom_body3" style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>
                                        {estimationData.grandTotalManHrs ?? "#"}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>

                    </div>
                    <div className="table-responsive col-md-12" style={{ width: '100%', maxHeight: '60vh', overflowY: 'auto' }}>
                        <table className="table table-bordered" style={{ width: '100%', borderCollapse: 'collapse', border: '1.01px solid #E0E8EF' }}>
                            <thead style={{ backgroundColor: "#F5F8FA", position: 'sticky', top: '0', zIndex: 1, borderBottom: '1px solid #E0E8EF' }}>
                                <tr>
                                    <th className="vm_custom_body3" style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Total in Words :

                                    </th>
                                    <th className="vm_custom_body3"
                                        style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>

                                        <span style={{ fontWeight: 'bold' }}>   Amount : </span>
                                        {"₹ " + (estimationData.grandTotalCost ?? "#")}
                                    </th>

                                </tr>
                            </thead>
                            <tbody>


                                <tr>
                                    <td className="table-rows vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>
                                        <span className="vm_custom_body3">{estimationData.totalAmountInWords ?? "#"}</span>

                                    </td>
                                    <td className="vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>

                                        <p className="vm_custom_body3">
                                            <span style={{ fontWeight: 'bold' }}>SGST : </span>
                                            {"₹ " + (estimationData.sgst ?? "#")}
                                        </p>
                                        <p className="vm_custom_body3">
                                            <span style={{ fontWeight: 'bold' }}>CGST : </span>
                                            {"₹ " + (estimationData.cgst ?? "#")}
                                        </p>
                                        <p className="vm_custom_body3">
                                            <span style={{ fontWeight: 'bold' }}>Total GST Amount : </span>
                                            {"₹ " + (estimationData.totalGst ?? "#")}
                                        </p>



                                    </td>


                                </tr>

                                <tr>
                                    <td className="table-rows vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>
                                        <span className="vm_custom_body3"> Terms and Conditions</span>
                                    </td>

                                    <td className="table-rows vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>
                                        <span className="vm_custom_body3">
                                            <span style={{ fontWeight: 'bold' }}> Payable Amount:  </span>
                                            {estimationData.totalCostWithGst ?? "#"}</span>
                                    </td>

                                </tr>
                                <tr>
                                    <td rowSpan={3} className="vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>

                                        <p className="vm_custom_body3" >  Subject to Pune Jurisdiction.</p>
                                        <p className="vm_custom_body3" >   Our responsibility ceases as soon as the service delivered.</p>

                                    </td>
                                    <td className="table-rows vm_custom_body3" style={{ border: '1.01px solid #E0E8EF' }}>
                                        <span className="vm_custom_body3" style={{ alignSelf: 'center' }}> Signature</span>

                                    </td>



                                </tr>


                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        );
    }
}

export default QuotationApproval;
